import React from 'react'

interface CardsLayoutProps {
  children: React.ReactNode
  className?: string
  borderRadius?: string
  bg?: string
  style?: React.CSSProperties
}

const CardsLayout = ({
  children,
  className = '',
  borderRadius = 'rounded-[20px]',
  bg = 'linear-gradient(116deg,  #F742A2 2.68%, #F742A2 37.5%, #37C8F5 88.54%)',
  style = {},
}: CardsLayoutProps) => {
  return (
    <div
      className={` p-[1.5px] ${className} ${borderRadius}`}
      style={{
        height: 'fit-content',
        background: bg,
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default CardsLayout
